import React, { useEffect } from "react";

/**
 * Simple Auto‑Toast Component
 *
 * Props:
 * - show: boolean — whether toast is visible
 * - message: string — text to show
 * - type: "success" | "error" | "info"
 * - duration: number (ms) — default 2500
 *
 * Usage:
 * <Toast show={showToast} message="Player added!" type="success" />
 */

const Toast = ({ show, message, type = "info", duration = 2500, onClose }) => {
  const backgroundColor =
    type === "success"
      ? "#3d82ff"
      : type === "error"
      ? "#ff62a5"
      : "rgba(0,0,0,0.75)";

  const shouldAutoDismiss = type === "success";
  const shouldShowClose = type === "error" || type === "info";

  useEffect(() => {
    if (show && shouldAutoDismiss) {
      const timer = setTimeout(() => {
        onClose && onClose();
      }, duration);
      return () => clearTimeout(timer);
    }
  }, [show, duration, onClose, shouldAutoDismiss]);

  if (!show) return null;

  return (
    <div
      style={{
        position: "fixed",
        bottom: "30px",
        left: "50%",
        transform: "translateX(-50%)",
        padding: "16px 26px",
        backgroundColor,
        color: "white",
        borderRadius: "8px",
        fontSize: "16px",
        zIndex: 2000,
        boxShadow: "0 2px 10px rgba(0,0,0,0.25)",
        animation: "toastFadeInOut 2.5s ease-in-out forwards"
      }}
    >
      <div style={{ position: "relative", paddingRight: shouldShowClose ? "24px" : "0" }}>
        {message}

        {shouldShowClose && (
          <button
            onClick={onClose}
            style={{
              position: "absolute",
              top: "-4px",
              right: "-4px",
              background: "transparent",
              border: "none",
              color: "white",
              fontSize: "18px",
              cursor: "pointer",
              lineHeight: "1",
              padding: "4px"
            }}
          >
            ✕
          </button>
        )}
      </div>
    </div>
  );
};

export default Toast;

const styles = document.createElement("style");
styles.innerHTML = `
@keyframes toastFadeInOut {
  0% { opacity: 0; transform: translateX(-50%) translateY(10px); }
  10% { opacity: 1; transform: translateX(-50%) translateY(0px); }
  90% { opacity: 1; transform: translateX(-50%) translateY(0px); }
  100% { opacity: 0; transform: translateX(-50%) translateY(10px); }
}
`;
document.head.appendChild(styles);
